import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { toast } from "sonner";
import { SecretInput, UsageBar, n4 } from "./AiSitesModal";

const fmt = (iso) => new Date(iso).toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });

export default function AiSettings() {
  const [pinSet, setPinSet] = useState(false);
  const [oldPin, setOldPin] = useState("");
  const [newPin, setNewPin] = useState("");
  const [bal, setBal] = useState("");
  const [lim, setLim] = useState("");
  const [usage, setUsage] = useState(null);
  const [adm, setAdm] = useState({ odemeler: [], cuzdanlar: [] });
  const [pr, setPr] = useState(null);
  const [pf, setPf] = useState({});
  const load = () => {
    api.get("/ai-site/pin").then((r) => setPinSet(r.data.set));
    api.get("/ai-site/usage").then((r) => setUsage(r.data));
    api.get("/ai-credits/admin").then((r) => setAdm(r.data));
    api.get("/ai-prices").then((r) => setPr(r.data));
  };
  const savePr = async () => { setPr((await api.put("/ai-prices", { data: pf })).data); setPf({}); toast.success("FİYATLAR KAYDEDİLDİ"); };
  const PI = (k, ph) => <Input data-testid={`ai-price-${k}`} value={pf[k] ?? ""} onChange={(e) => setPf({ ...pf, [k]: e.target.value })} placeholder={ph} className="h-8 w-28 border-slate-700 bg-slate-800 text-xs" />;
  useEffect(load, []);

  const savePin = async () => { await api.put("/ai-site/pin", { data: { pin: newPin, old_pin: oldPin } }); setNewPin(""); setOldPin(""); setPinSet(true); toast.success("PIN KAYDEDİLDİ"); };
  const saveBal = async () => { setUsage((await api.put("/ai-site/balance", { data: { balance: bal } })).data); setBal(""); toast.success("BAKİYE KAYDEDİLDİ"); };
  const saveLim = async () => { setUsage((await api.put("/ai-site/limit", { data: { limit: lim } })).data); setLim(""); toast.success("UYARI SINIRI KAYDEDİLDİ"); };
  const view = async (id) => { const r = await api.get(`/ai-credits/${id}/file`, { responseType: "blob" }); window.open(URL.createObjectURL(r.data), "_blank"); };
  const act = async (id, a) => { await api.post(`/ai-credits/${id}/${a}`, {}); toast.success(a === "approve" ? "KREDİ YÜKLENDİ" : "REDDEDİLDİ"); load(); };

  return (
    <div data-testid="ai-settings" className="max-w-4xl space-y-3">
      <div className="space-y-2 rounded-lg border border-slate-800 bg-slate-900 p-3">
        <div className="text-sm font-bold text-white">SİSTEM YAPAY ZEKASI — YAPIMCI ADMİN</div>
        <div className="flex items-center gap-2">
          {pinSet && <SecretInput testid="ai-old-pin-input" value={oldPin} onChange={setOldPin} placeholder="ESKİ PIN" />}
          <SecretInput testid="ai-new-pin-input" value={newPin} onChange={setNewPin} placeholder={pinSet ? "YENİ PIN" : "PIN BELİRLEYİN (EN AZ 4 HANE)"} />
          <Button data-testid="ai-pin-save" disabled={newPin.trim().length < 4} onClick={savePin} className="h-9 bg-slate-700 hover:bg-slate-600">PIN KAYDET</Button>
        </div>
        <div className="flex items-center gap-2">
          <Input data-testid="ai-balance-input" value={bal} onChange={(e) => setBal(e.target.value)} placeholder="EMERGENT PANELDEKİ GÜNCEL KREDİ BAKİYENİZ" className="h-9 border-slate-700 bg-slate-800" />
          <Button data-testid="ai-balance-save" disabled={!bal.trim()} onClick={saveBal} className="h-9 bg-slate-700 hover:bg-slate-600">BAKİYE KAYDET</Button>
        </div>
        <div className="flex items-center gap-2">
          <Input data-testid="ai-limit-input" value={lim} onChange={(e) => setLim(e.target.value)} placeholder={`KREDİ UYARI SINIRI${usage?.limit != null ? ` — ŞU AN: ${n4(usage.limit)}` : ""}`} className="h-9 border-slate-700 bg-slate-800" />
          <Button data-testid="ai-limit-save" disabled={!lim.trim()} onClick={saveLim} className="h-9 bg-slate-700 hover:bg-slate-600">SINIR KAYDET</Button>
        </div>
        {usage && <UsageBar u={usage} />}
      </div>

      {pr && (
      <div data-testid="ai-prices" className="rounded-lg border border-slate-800 bg-slate-900 p-3">
        <div className="mb-2 text-sm font-bold text-white">SORGU FİYATLARI — YAPAY ZEKA</div>
        <table className="w-full text-xs">
          <thead className="text-left text-slate-400"><tr><th className="py-1">İŞLEM</th><th>SORU (GİRİŞ) MALİYETİ</th><th>CEVAP (ÇIKIŞ) MALİYETİ</th><th>YAPAY ZEKANIN SİZE MALİYETİ</th><th>SİZİN FİYATINIZ</th><th>YENİ FİYAT</th><th>KÂR / SORGU</th></tr></thead>
          <tbody>
            {[["scan", "SİTE TARAMA"], ["ask", "YAPAY ZEKAYA SOR"]].map(([k, l]) => { const c = pr.maliyet[k]; return (
              <tr key={k} data-testid={`ai-price-row-${k}`} className="border-t border-slate-800 text-slate-200">
                <td className="py-1 font-bold">{l}</td><td>{n4(c.soru)}</td><td>{n4(c.cevap)}</td>
                <td className="font-bold text-amber-300">{n4(c.toplam)} KREDİ{!c.olcum && " (TAHMİN)"}{c.olcum && <span className="text-slate-500"> · {c.adet} ÖLÇÜM</span>}</td>
                <td className="font-bold text-emerald-300">{n4(pr[k])} KREDİ</td><td>{PI(k, "ÖR: 0,05")}</td>
                <td className={pr[k] - c.toplam >= 0 ? "text-emerald-400" : "text-rose-400"}>{n4(pr[k] - c.toplam)} KREDİ</td>
              </tr>); })}
          </tbody>
        </table>
        <div className="mt-2 flex flex-wrap items-center gap-3 text-xs text-slate-300">
          <span>1 KREDİ = <b className="text-white">{n4(pr.tl)} TL</b></span>{PI("tl", "YENİ TL")}
          <span>EN AZ ALIM: <b className="text-white">{pr.min} KREDİ</b></span>{PI("min", "YENİ ADET")}
          <Button data-testid="ai-price-save" disabled={!Object.values(pf).some((v) => String(v).trim())} onClick={savePr} className="h-8 bg-blue-600 text-xs hover:bg-blue-700">FİYATLARI KAYDET</Button>
        </div>
        <p className="mt-2 text-[11px] text-slate-500">MALİYET EMERGENT KREDİSİ CİNSİNDENDİR (1 USD = 5 KREDİ). FİRMALARDAN HER SORGUDA SİZİN FİYATINIZ DÜŞER. ÖRN: {pr.min} KREDİ = {n4(pr.min * pr.tl)} TL → ≈ {Math.floor(pr.min / pr.scan)} SİTE TARAMA VEYA ≈ {Math.floor(pr.min / pr.ask)} SORU.</p>
      </div>)}

      <div className="rounded-lg border border-slate-800 bg-slate-900 p-3">
        <div className="mb-2 text-sm font-bold text-white">FİRMA KREDİ ÖDEME BİLDİRİMLERİ</div>
        <table data-testid="ai-payments-table" className="w-full text-xs">
          <thead className="text-left text-slate-400"><tr><th className="py-1">TARİH</th><th>FİRMA</th><th>KULLANICI</th><th>KREDİ</th><th>TUTAR</th><th>AÇIKLAMA</th><th>DEKONT</th><th>DURUM</th><th /></tr></thead>
          <tbody>
            {adm.odemeler.length === 0 && <tr><td colSpan={9} className="py-3 text-center text-slate-500">BİLDİRİM YOK</td></tr>}
            {adm.odemeler.map((p) => (
              <tr key={p.id} data-testid={`ai-payment-${p.id}`} className="border-t border-slate-800 text-slate-200">
                <td className="py-1">{fmt(p.created_at)}</td><td className="font-bold">{p.firma}</td><td>{p.by}</td><td>{p.kredi}</td><td>{p.tutar.toLocaleString("tr-TR")}</td><td className="text-slate-400">{p.aciklama}</td>
                <td>{p.dekont ? <Button data-testid={`ai-payment-file-${p.id}`} onClick={() => view(p.id)} className="h-7 bg-sky-800 px-2 text-xs hover:bg-sky-700">GÖR</Button> : <span className="text-slate-500">YOK</span>}</td>
                <td className={p.durum === "ONAYLANDI" ? "text-emerald-400" : p.durum === "REDDEDİLDİ" ? "text-rose-400" : "text-amber-400"}>{p.durum}</td>
                <td className="flex gap-1 py-1">{p.durum === "BEKLİYOR" && <>
                  <Button data-testid={`ai-payment-approve-${p.id}`} onClick={() => act(p.id, "approve")} className="h-7 bg-emerald-700 px-2 text-xs hover:bg-emerald-600">ONAYLA</Button>
                  <Button data-testid={`ai-payment-reject-${p.id}`} onClick={() => act(p.id, "reject")} className="h-7 bg-rose-800 px-2 text-xs hover:bg-rose-700">REDDET</Button></>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="rounded-lg border border-slate-800 bg-slate-900 p-3">
        <div className="mb-2 text-sm font-bold text-white">FİRMA KREDİ BAKİYELERİ</div>
        <table data-testid="ai-wallets-table" className="w-full text-xs">
          <thead className="text-left text-slate-400"><tr><th className="py-1">FİRMA</th><th>KALAN KREDİ</th><th>HARCANAN</th><th>SORGU</th><th>KALAN SORGU (TAHMİNİ)</th></tr></thead>
          <tbody>
            {adm.cuzdanlar.length === 0 && <tr><td colSpan={5} className="py-3 text-center text-slate-500">KREDİSİ OLAN FİRMA YOK</td></tr>}
            {adm.cuzdanlar.map((w) => (
              <tr key={w.tenant} className="border-t border-slate-800 text-slate-200"><td className="py-1 font-bold">{w.firma}</td><td>{n4(w.bakiye)}</td><td>{n4(w.harcanan)}</td><td>{w.sorgu}</td><td>≈ {w.kalan_sorgu.toLocaleString("tr-TR")}</td></tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
